<script lang="ts">
    import type { Price } from '@shared/types/types';

    interface Props {
        price: Price;
        strikethrough?: boolean;
    }

    let { price, strikethrough = true }: Props = $props();
</script>

{#if price.suggestedRetailPrice}
    <span class="oc-copy-75"
        >UVP <span class={['reptile-price__priceValue', strikethrough && 'reptile-price__priceValue--strikethrough']}
            >{price.suggestedRetailPrice} €</span
        ></span
    >
{/if}

<style lang="scss">
    .reptile-price {
        &__priceValue {
            white-space: nowrap;

            &--strikethrough {
                text-decoration: line-through;
            }
        }
    }
</style>
